import { useEffect, useRef, useState } from 'react';
import { Animated, Platform, StyleSheet, View } from 'react-native';

import { useColor } from '@/hooks/useColor';

type LoaderProps = {
  color?: string;
  size?: number;
  speed?: number;
  dotsNumber?: number;
};

export default function Dots(props: LoaderProps) {
  const [active, setActive] = useState(1);
  const colors = useColor();
  const { color = colors.primary, speed = 300, size = 5, dotsNumber = 3 } = props;
  const seqDots = [...Array<number>(dotsNumber).keys()];
  useEffect(() => {
    const interval = setInterval(() => {
      setActive(active > seqDots.length - 1 ? 0 : active + 1);
    }, speed);
    return () => clearInterval(interval);
  });
  return (
    <View style={styles.container}>
      {seqDots.map((i, idx) => (
        <Dot key={idx} active={i === active} duration={speed} {...{ color, size }} />
      ))}
    </View>
  );
}

type DotProps = {
  active: boolean;
  size: number;
  color?: string;
  duration?: number;
};

const Dot = ({ active, color, duration, size }: DotProps) => {
  const animationValue = useRef(new Animated.Value(1)).current;

  const scaleDot = () => {
    Animated.sequence([
      Animated.timing(animationValue, {
        duration,
        toValue: 2,
        useNativeDriver: Platform.OS === 'web' ? false : true
      }),
      Animated.timing(animationValue, {
        toValue: 1,
        duration,
        useNativeDriver: Platform.OS === 'web' ? false : true
      })
    ]).start();
  };

  useEffect(() => {
    if (active) scaleDot();
  });

  return (
    <Animated.View
      style={{
        transform: [{ scale: animationValue }],
        width: size,
        height: size,
        borderRadius: size / 2,
        marginHorizontal: size * 1.2,
        backgroundColor: color
      }}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-end'
  }
});
